import classNames from 'classnames'

const DropdownItem = (props) => {
  const { customClass, href, onClick, title, variant, value } = props
  const classes = classNames(
    variant ? 'control-dropdown__item--' + variant : '',
    customClass
  )

  return (
    <a
      class={classes}
      href={href}
      onClick={onClick}
      value={value}
    >
      {title}
    </a>
  )
}

export default DropdownItem
